import Vue from 'vue';
import VueRouter from 'vue-router';

import BookList from '@/components/books/List';
import BookEdit from '@/components/books/Edit';
import BookView from '@/components/books/View';

import AuthorList from '@/components/authors/List';
import AuthorEdit from '@/components/authors/Edit';
import AuthorView from '@/components/authors/View';

import LawyerList from '@/components/lawyers/List';
import LawyerEdit from '@/components/lawyers/Edit';
import LawyerView from '@/components/lawyers/View';

import CategoryList from '@/components/categories/List';
import CategoryEdit from '@/components/categories/Edit';
import CategoryView from '@/components/categories/View';

import PublisherList from '@/components/publishers/List';
import PublisherEdit from '@/components/publishers/Edit';

import Slider from '@/components/Slider';

import Impressum from '@/components/Impressum';

import Configuration from '@/components/Configuration';

import BackupsList from '@/components/Backups/List';

import DashBoard from '@/components/dashboard/DashBoard';
import Login from '@/components/Login';

import store from '@/store';

import firebase from 'firebase/app';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'DashBoard',
      component: DashBoard
    },

    {
      path: '/login',
      name: 'Login',
      component: Login
    },

    {
      path: '/books',
      name: 'BookList',
      component: BookList,
    },

    {
      path: '/books/create',
      name: 'BookCreate',
      component: BookEdit,
    },

    {
      path: '/books/:id(\\w+)/edit/',
      name: 'BookEdit',
      component: BookEdit,
    },

    {
      path: '/books/:id(\\w+)/view',
      name: 'BookView',
      component: BookView,
    },

    {
      path: '/authors',
      name: 'AuthorList',
      component: AuthorList,
    },

    {
      path: '/authors/create',
      name: 'AuthorCreate',
      component: AuthorEdit,
    },

    {
      path: '/authors/:id(\\w+)/edit',
      name: 'AuthorEdit',
      component: AuthorEdit,
    },

    {
      path: '/authors/:id(\\w+)/view',
      name: 'AuthorView',
      component: AuthorView,
    },

    //lawyers
    {
      path: '/lawyers',
      name: 'LawyerList',
      component: LawyerList,
    },

    //slider
    {
      path: '/slider',
      name: 'Slider',
      component: Slider,
    },

    {
      path: '/lawyers/create',
      name: 'LawyerCreate',
      component: LawyerEdit,
    },

    {
      path: '/lawyers/:id(\\w+)/edit',
      name: 'LawyerEdit',
      component: LawyerEdit,
    },

    {
      path: '/lawyers/:id(\\w+)/view',
      name: 'LawyerView',
      component: LawyerView,
    },

    {
      path: '/publishers',
      name: 'PublisherList',
      component: PublisherList,
    },

    {
      path: '/publishers/create',
      name: 'PublisherCreate',
      component: PublisherEdit,
    },

    {
      path: '/categories',
      name: 'CategoryList',
      component: CategoryList,
    },

    {
      path: '/categories/:id(\\d+)/edit',
      name: 'CategoryEdit',
      component: CategoryEdit,
    },

    {
      path: '/categories/create',
      name: 'CategoryCreate',
      component: CategoryEdit,
    },

    {
      path: '/categories/:id(\\d+)/view',
      name: 'CategoryView',
      component: CategoryView,
    },

    {
      path: '/impressum/',
      name: 'Impressum',
      component: Impressum,
    },

    {
      path: '/configuration/',
      name: 'Configuration',
      component: Configuration,
    },

    {
      path: '/backups/',
      name: 'BackupsList',
      component: BackupsList,
    },

    {
      path: '*',
      component: {
        template: '<h3>Page Not Found</h3>'
      }
    }
  ],

  mode: 'history'
});

router.beforeEach((to, from, next) => {
  /**
   * If authenticated -> check only path from redirect from login page
   */
  if (store.getters.isAuthenticated) {
    if (to.path == '/login') {
      next('/')
    } 
    next()
  } else {
    store.dispatch('checkAuth')
      .then(response => {
        if (to.path == '/login') {
          next('/')
        } else {
          next()
        }
      })
      .catch(err => {
        if (to.path != '/login') {
          next('/login')
        }

        next()
      })
  }
})

export default router;
